"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setOpen = exports.get = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageStarmaps_sidecar_1 = require("@voyage/starmap/voyageStarmaps-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageGameMode_game_hyperspace_sidecar_1 = require("@voyage/gamemodes/voyageGameMode_game_hyperspace-sidecar");
var voyageGameStatus_sidecar_1 = require("@voyage/game-status/voyageGameStatus-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGButtons_sidecar_1 = require("@voyage/ui/voyageUiGButtons-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(false);
        addButtons();
        render();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 700;
    var th = 800;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiMenu);
    canvas.autoOffset = false;
    canvas.ox = 0;
    canvas.oy = 0;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {
        buttonJump: null,
    });
    return obj;
};
var addButtons = function () {
    var x = 20;
    var y = 40;
    var obj = get();
    var addButton = function (text, action) {
        var button = voyageUiGButtons_sidecar_1.voyageUiGButtons.create(text, x, y, action);
        button.w = 200;
        obj.buttons.push(button);
        // y += 60
        // if (y > obj.targetHeight - 60) {
        //   x += 200 + 20
        //   y = 40
        // }
        return button;
    };
    obj.buttons = [];
    // let status = voyageGameStatus.get()
    // l.forEach(list, (c) => {
    //   if (c.locationName === status.locationName) {
    //     return
    //   }
    //   addButton(c.locationName, () => {
    //     if (status.jumpCharge >= 98) {
    //       voyageMessageJump.sendMessageRequest({
    //         command: EJumpCommand.Request,
    //         // isStarbase: c.isStarbase,
    //         i: 0,
    //         j: 0,
    //         locationName: c.locationName,
    //         missionType: c.missionType,
    //       })
    //       setOpen(false)
    //     } else {
    //       voyageSounds.playFailure()
    //     }
    //   })
    // })
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    x = 100;
    y = gb.height - 250;
    obj.buttonJump = addButton('Jump', function () {
        voyageStarmaps_sidecar_1.voyageStarmaps.tryJumpToTarget();
    });
    x += 250;
    addButton('Cancel', function () {
        exports.setOpen(false);
    });
};
// TODO: add potential locations
// const updateList = (list: IVoyageNavData[]) => {
//   let x = 20
//   let y = 40
//   let obj = get()
//   const addButton = (text: string, action: () => void) => {
//     let button = voyageUiGButtons.create(text, x, y, action)
//     button.w = 200
//     obj.buttons.push(button)
//     y += 60
//     if (y > obj.targetHeight - 60) {
//       x += 200 + 20
//       y = 40
//     }
//   }
//   obj.buttons = []
//   let status = voyageGameStatus.get()
//   l.forEach(list, (c) => {
//     if (c.locationName === status.locationName) {
//       return
//     }
//     addButton(c.locationName, () => {
//       if (status.jumpCharge >= 98) {
//         voyageMessageJump.sendMessageRequest({
//           command: EJumpCommand.Request,
//           // isStarbase: c.isStarbase,
//           i: 0,
//           j: 0,
//           locationName: c.locationName,
//           missionType: c.missionType,
//         })
//         setOpen(false)
//       } else {
//         voyageSounds.playFailure()
//       }
//     })
//   })
//   y += 60
//   addButton('Cancel', () => {
//     setOpen(false)
//   })
// }
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    if (!obj.isOpen) {
        return;
    }
    var addText = function (text, x, y, scale) {
        if (scale === void 0) { scale = 1; }
        var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, x, y, obj.layer);
        stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
        stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 3 * scale);
        obj.texts.push(_text);
        return _text;
    };
    var x = 0;
    var y = 0;
    var w = obj.targetWidth;
    var h = obj.targetHeight;
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    // voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h)
    x = 100;
    y = 150;
    addText('Starmap', x, y, 2); // + 25 - 2)
    var hovered = voyageStarmaps_sidecar_1.voyageStarmaps.get().hoveredTile;
    if (hovered) {
        var text = '';
        if (hovered.location) {
            text = 'Unknown';
            if (hovered.isRevealed) {
                text = '' + hovered.location.text;
            }
        }
        // if(hovered.location.)
        if (text) {
            addText(text, hovered.x + 28, hovered.y);
        }
    }
    x = 100 + 10;
    y = gb.height - 250 - 50;
    var status = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    addText('Currently at ' + status.locationName, x, y);
    y += 24;
    addText('Jump drive ' + status.jumpCharge + '%', x, y);
    y += 24;
    assert_sidecar_1.assert.notNil(obj.buttonJump);
    obj.buttonJump.isDisabled =
        status.jumpCharge < 98 || voyageGameMode_game_hyperspace_sidecar_1.voyageGameMode_game_hyperspace.getIsInHyperspace();
    // let b = obj.selectedBattle
    // if (b) {
    //   addText(b.name, x, y)
    //   y += 40
    //   addText(b.desc, x, y)
    //   y += 40
    //   addText('Budget: $' + b.budget, x, y)
    // }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
var setOpen = function (isOpen) {
    var obj = get();
    if (isOpen && !obj.isOpen) {
        // voyageJsonServerInterface.list((list) => {
        //   updateList(list)
        // })
        // updateList(voyageUiBuyStuff_data.dataList) //['crew', 'fire extinguisher', 'wrench', 'torpedo'])
    }
    voyageStarmaps_sidecar_1.voyageStarmaps.setVisible(isOpen);
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
    exports.update();
};
exports.setOpen = setOpen;
var update = function () {
    var obj = get();
    var status = voyageGameStatus_sidecar_1.voyageGameStatus.get();
    // if (_lastLocationName !== status.locationName) {
    // _needsRefresh = true
    // _lastLocationName = status.locationName
    // }
    if (obj.isOpen) {
        // if (_needsRefresh) {
        //   updateList(voyageUiNav_data.getAll()) //['crew', 'fire extinguisher', 'wrench', 'torpedo'])
        //   _needsRefresh = false
        // }
    }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
    render();
};
exports.update = update;
